import React from 'react'
import { Tooltip, IconButton } from '@mui/material'
import InfoOutlineIcon from '@mui/icons-material/InfoOutline'

export interface UserGuideTooltipProps {
  tooltipText: string
  link?: string
  placement?: any
  ariaLabel?: string
  className?: string
}

const UserGuideTooltip: React.FC<UserGuideTooltipProps> = ({
  tooltipText,
  link,
  placement = 'right-start',
  ariaLabel,
  className,
}) => {
  return (
    <Tooltip
      title={tooltipText}
      placement={placement}
      arrow
      slotProps={{
        tooltip: {
          sx: {
            bgcolor: '#D3E8FF',
            color: '#07135F',
            padding: '16px',
            fontSize: '14px',
            '& .MuiTooltip-arrow': {
              color: '#D3E8FF',
            },
          },
        },
      }}
    >
      {link ? (
        <a
          href={link}
          target="_blank"
          rel="noreferrer"
          aria-label={ariaLabel}
          className={className}
        >
          <IconButton sx={{ padding: '0 6px' }}>
            <InfoOutlineIcon fontSize="small" sx={{ color: '#FF029E' }} />
          </IconButton>
        </a>
      ) : (
        <IconButton
          aria-label={ariaLabel}
          className={className}
          sx={{ padding: '0 6px' }}
        >
          <InfoOutlineIcon fontSize="small" sx={{ color: '#FF029E' }} />
        </IconButton>
      )}
    </Tooltip>
  )
}

export default UserGuideTooltip
